import { HttpClient } from '@shared/adapters/HttpClient';

export interface CoverageIntegrationItem {
  courier_id: string;
  courier: {
    name: string;
  };
  courier_integration_id: string;
  courier_integration: {
    name: string;
  };
  courier_service_id: number;
  courier_service_code: string;
  courier_service_description: string;
  courier_service: {
    description: string;
  };
  allowed: boolean;
  matched_rule_id: number | null;
  matched_rule_priority: number | null;
  payment_method_id: number | null;
}

export interface CoverageEvaluationResponse {
  items: CoverageIntegrationItem[];
}

export class CoverageEvaluationApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async evaluateIntegrationsByOrder(
    countryId: number,
    postalCode: string,
    paymentMethodId?: number
  ): Promise<CoverageEvaluationResponse> {
    try {
      console.log(
        '🔍 CoverageEvaluationApiAdapter - Evaluating integrations:',
        {
          countryId,
          postalCode,
          paymentMethodId,
        }
      );

      const params = new URLSearchParams({
        country_id: countryId.toString(),
        postal_code: postalCode,
      });

      if (paymentMethodId !== undefined) {
        params.append('payment_method_id', paymentMethodId.toString());
      }

      const response = await this.httpClient.get<CoverageEvaluationResponse>(
        `/couriers/coverage/evaluate/integrations-by-order?${params.toString()}`
      );

      console.log('🔍 CoverageEvaluationApiAdapter - Response:', response);

      return {
        items: response.items || [],
      };
    } catch (error: any) {
      console.log('🔍 CoverageEvaluationApiAdapter - Error:', error);
      throw error;
    }
  }
}

